import { render, staticRenderFns } from "./AdvertiserContactDelete.vue?vue&type=template&id=265ba5e0&scoped=true"
import script from "./AdvertiserContactDelete.vue?vue&type=script&lang=js"
export * from "./AdvertiserContactDelete.vue?vue&type=script&lang=js"
import style0 from "./AdvertiserContactDelete.vue?vue&type=style&index=0&id=265ba5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265ba5e0",
  null
  
)

export default component.exports